module.exports = __webpack_public_path__ + "static/media/qualifield.25134062.svg";